<p class="textoP my-5">
    {{message}}
    <br>
    Por favor, reintente nuevamente
</p>
<div class="mt-5 mb-5">
    <app-custom-button label="Reintentar"
                       button_style="outline"   
                       [newRoute]="['introduccion']">
    </app-custom-button>
</div>
